
import index from '@/pages/index'
var IndexRouter = {
  path: '/',
  name: 'home',
  redirect: '/index'
}

var appRouter = [
  {
    path: '/index',
    name: 'index',
    component: index
  },
  {
    path: '/tech',
    name: 'tech',
    component: () => import('@/pages/tech'),
  },
  {
    path: '/tech/detail',
    name: 'techDeatil',
    component: () => import('@/pages/techDetail'),
  },
  {
    path:'/service',
    name:'service',
    component: () => import('@/pages/service')
  },
  {
    path:'/other',
    name:'other',
    component: () => import('@/pages/other')
  },
  {
    path:'/guide',
    name:'guide',
    component: () => import('@/pages/guide')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('@/pages/contact'),
  }
]
export const routers = [
  IndexRouter,
  ...appRouter
]



// WEBPACK FOOTER //
// ./src/router/routers.js